import { render, staticRenderFns } from "./ContentTextGenericModule.vue?vue&type=template&id=3cfe5fea&"
import script from "./ContentTextGenericModule.ts?vue&type=script&lang=ts&"
export * from "./ContentTextGenericModule.ts?vue&type=script&lang=ts&"
import style0 from "./ContentTextGenericModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports